import script from "./PaymentSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentSettings.vue?vue&type=style&index=0&id=3d1aa36a&lang=scss&scoped=true"
import "./PaymentSettings.vue?vue&type=style&index=1&id=3d1aa36a&lang=scss"
script.__scopeId = "data-v-3d1aa36a"

export default script